import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Lightbulb } from 'lucide-react';

/** Bottom card: industry-specific drivers (chips) + insights (cards). */
export function IndustryInsights({ comparison, industryKey, industryLabel }) {
  const { t } = useTranslation();
  return (
    <>
      {comparison.drivers && comparison.drivers.length > 0 && (
        <Card className="bg-white border-[#DDE1E5]">
          <CardHeader className="pb-3">
            <CardTitle className="text-sm text-[#66707A] uppercase tracking-wider">
              {t('benchmark.driversTitle')}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex flex-wrap gap-2" data-testid="benchmark-drivers">
              {comparison.drivers.map((d) => (
                <span
                  key={d.id}
                  className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium ${
                    d.tone === 'positive'
                      ? 'bg-[#F1F8E8] text-[#3F6114] border border-[#527F19]/25'
                      : 'bg-[#F5F6F7] text-[#3A4249] border border-[#DDE1E5]'
                  }`}
                  data-testid={`driver-${d.id}`}
                >
                  {t(d.key, { ...d.params, defaultValue: d.label })}: <span className="font-mono">{d.impact}</span>
                </span>
              ))}
            </div>
            <p className="mt-3 text-xs text-[#8A929B]">{t('benchmark.driversDesc')}</p>
          </CardContent>
        </Card>
      )}

      <Card className="bg-white border-[#DDE1E5]">
        <CardHeader className="pb-3">
          <CardTitle className="text-sm text-[#66707A] uppercase tracking-wider flex items-center gap-2">
            <Lightbulb className="w-4 h-4 text-[#527F19]" />
            {t('benchmark.insightsTitle', { industry: industryLabel })}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="mb-3 text-xs text-[#8A929B]" data-testid="benchmark-insights-disclaimer">
            {t('benchmark.insightsDisclaimer')}
          </p>
          <div className="grid md:grid-cols-2 gap-3">
            {comparison.insights.map((insight, i) => (
              <div
                key={`${industryKey}-insight-${i}`}
                className="p-3 rounded-lg bg-[#F5F6F7] border border-[#DDE1E5] text-sm text-[#3A4249] leading-relaxed"
                data-testid={`benchmark-insight-${i}`}
              >
                {t(`benchmark.insights.${industryKey}.${i}`, { defaultValue: insight })}
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </>
  );
}
